import * as React from 'react';
import { Table } from '@ixicare/ui';
import { t } from '~/i18n';
import { BillingRow } from './useBillingBreakdown';
import { deviceTypeLabel, profileGroup, profileTypeLabel, rowTypeLabel } from './billingLabels';

interface BillingTableProps {
  rows: BillingRow[];
  deviceTypes: string[];
  profileTypes: string[];
}

const formatCount = (count: number): string => (count > 0 ? String(count) : '–');

export const BillingTable: React.FC<BillingTableProps> = ({ rows, deviceTypes, profileTypes }) => (
  <Table>
    <Table.Head>
      <Table.Row>
        <Table.HeadCol>{t('billing.table.type')}</Table.HeadCol>
        <Table.HeadCol>{t('billing.table.name')}</Table.HeadCol>
        {profileTypes.map((type) => (
          <Table.HeadCol key={`profile-${type}`}>{profileTypeLabel(type)}</Table.HeadCol>
        ))}
        {deviceTypes.map((type) => (
          <Table.HeadCol key={`device-${type}`}>{deviceTypeLabel(type)}</Table.HeadCol>
        ))}
      </Table.Row>
    </Table.Head>
    <Table.Body>
      {rows.map((row) => {
        const profileCount = (group: string) =>
          row.usage.profiles.items
            .filter((item) => profileGroup(item.profileType) === group)
            .reduce((sum, item) => sum + item.count, 0);
        const deviceCount = (type: string) =>
          row.usage.devices.items.find((item) => item.deviceType === type)?.count ?? 0;
        const bold = row.kind === 'org' ? 600 : undefined;

        return (
          <Table.Row key={row.key}>
            <Table.Col style={{ fontWeight: bold }}>{rowTypeLabel(row.kind)}</Table.Col>
            <Table.Col style={{ paddingLeft: 16 + row.depth * 20, fontWeight: bold }}>{row.name}</Table.Col>
            {profileTypes.map((type) => (
              <Table.Col key={`profile-${type}`}>{formatCount(profileCount(type))}</Table.Col>
            ))}
            {deviceTypes.map((type) => (
              <Table.Col key={`device-${type}`}>{formatCount(deviceCount(type))}</Table.Col>
            ))}
          </Table.Row>
        );
      })}
    </Table.Body>
  </Table>
);
